module.exports = __webpack_public_path__ + "static/media/SAS Chat Tone 2.7b25db79.mp3";